const getCompanyScopedArray = ({ items, ownerCompanyId = null, activeCompanyId = null } = {}) => {
  const normalizedItems = Array.isArray(items) ? items : [];
  const normalizedOwnerCompanyId = String(ownerCompanyId || '').trim();
  const normalizedActiveCompanyId = String(activeCompanyId || '').trim();

  if (!normalizedOwnerCompanyId || !normalizedActiveCompanyId || normalizedOwnerCompanyId === normalizedActiveCompanyId) {
    return normalizedItems;
  }

  return [];
};

export default getCompanyScopedArray;
